export const UPDATE_CARDS = "UPDATE_CARDS";
export const LOADING = "LOADING";
export const LOADED = "LOADED";
export const NAME ="NAME";
export const UPDATE_COMENT = "UPDATE_COMENT";
export const MESSAGE = "MESSAGE";




